import React from 'react';
import i18next from 'i18next';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';

import { getFormat, makeGraph } from 'lib/commonLib';
import { paramConverter } from 'modules/common';
import { localGraph } from 'lib/api/localreport';

import CurrentStatus from 'components/atoms/CurrentStatus';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const graphList = [
  {
    title: i18next.t('세션ROAS'),
    data: { line: ['TOT_EPRS_CNT', 'CLICK_CNT'] },
    yAxisData: {
      left: { CLICK_CNT: true },
      right: { TOT_EPRS_CNT: true },
    },
  },
];

class StatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      infoMessage: '',
      loading: false,
      error: false,
      noData: false,
    };
  }

  getData = () => {
    const { params, locale, t, location, handleGraphLoading } = this.props;
    const { uri } = queryString.parse(location.search);

    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });
    localGraph({ ...paramConverter(params), uri })
      .then((response) => {
        const { data } = response.data;
        if (data.length === 0) {
          this.setState({
            ...this.state,
            noData: true,
            loading: false,
            error: false,
          });
        } else if (typeof data !== 'undefined') {
          this.setState({
            ...this.state,
            primitiveData: data,
            noData: false,
            loading: false,
            error: false,
          });
          this.handleChangeGraph(graphList[0], 0)();
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
          noData: false,
        });
      })
      .finally(() => {
        handleGraphLoading(false);
      });
  };

  componentDidMount() {
    const { handleGraphLoading } = this.props;
    handleGraphLoading(true);
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params, handleGraphLoading } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      handleGraphLoading(true);
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    const { handleGraphLoading } = this.props;
    handleGraphLoading(true);
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    return originalDate;
  };

  xAxisTick = (tickProps) => {
    const { x, y, payload } = tickProps;
    const { value } = payload;

    const dayStr = this.makeLabel(true)(value);

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="middle">
          {dayStr}
        </text>
      </g>
    );
  };

  /**
   * 버튼 클릭하여 그래프 데이터 변경
   */
  handleChangeGraph =
    (
      { title, data, yAxisData, customizeData: customize, isPercent = false },
      index
    ) =>
    (e) => {
      const { primitiveData } = this.state;

      if (typeof data !== 'undefined' || primitiveData.length > 0) {
        const { graphData, dataKeys, customizeData, keyLabel, stackId } =
          makeGraph({ data, customize, primitiveData });

        const result = (
          <MultiplexChart
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            title={title}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            isPercent={isPercent}
            key={title}
          />
        );

        this.setState({
          ...this.state,
          curGraphComponent: result,
          selectedIdx: index,
        });
      } else {
        this.setState({
          ...this.state,
          noData: true,
        });
      }
    };

  render() {
    const { handleRefesh } = this;
    const { t } = this.props;
    const { infoMessage, curGraphComponent, loading, error, noData } =
      this.state;

    return (
      <SwitchingArea
        title={
          <>
            <InfoTitleArea
              title={t('지역별통계 데이터 그래프')}
              tooltipTitle={infoMessage}
              iconType="fainfoCircle"
              iconColor="graph"
            />
          </>
        }
        handleRefesh={handleRefesh}
      >
        {loading || noData || error ? (
          <CurrentStatus
            type={loading ? 'loading' : noData ? 'noData' : error && 'error'}
          />
        ) : (
          <ContentsWrap contentsCount={1}>{curGraphComponent}</ContentsWrap>
        )}
      </SwitchingArea>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withTheme(StatisticsGraph))
  )
);
